module.exports = __webpack_public_path__ + "img/logo_zone.c0a38da2.svg";